import api from './api';

export interface MarketingOverview {
  totalVisitors: number;
  identifiedVisitors: number;
  anonymousVisitors: number;
  returningVisitors: number;
  totalSessions: number;
  bookNowClicks: number;
  conversionRate: number;
  topSources: { source: string; count: number }[];
  topServices: { name: string; count: number }[];
}

export interface FunnelStep {
  step: string;
  count: number;
}

export interface MarketingVisitor {
  id: string;
  first_seen_at: string;
  last_seen_at: string;
  device_category: string | null;
  first_utm_source: string | null;
  customer_id: string | null;
}

export interface VisitorsResponse {
  data: MarketingVisitor[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export const marketingApi = {
  getOverview: (params?: { startDate?: string; endDate?: string }) => 
    api.get<{ success: boolean; data: MarketingOverview }>('/admin/marketing/overview', { params }),

  getFunnel: (params?: { startDate?: string; endDate?: string }) => 
    api.get<{ success: boolean; data: FunnelStep[] }>('/admin/marketing/funnel', { params }),

  getVisitors: (params?: { page?: number; limit?: number }) => 
    api.get<{ success: boolean; data: MarketingVisitor[]; meta: VisitorsResponse['meta'] }>('/admin/marketing/visitors', { params }),
};
